export default __webpack_public_path__ + "static/media/p3.2dacd1a0.jpeg";